import { ColDef } from '@ag-grid-enterprise/all-modules'
import i18n from '@/lang/i18n'
import { initialCrudModelBaseState, CrudModelPaginatorLaboratory } from '@/shared/models/cruds.models'
import { PaginatorLaboratoryDatasource } from '@/shared/resources/datasources/paginator/paginator-laboratory-datasource'
import { AgGridColumnType } from '@/shared/models/ag-grid.model'
import { configurationOntologyForAutomaticAssayService } from '@/modules/configurationModule/detail/automation/assays/services/configuration-ontology-for-automatic-assay/configuration-ontology-for-automatic-assay.service'
import { ConfigurationOntologyForAutomaticAssayResponse } from '@/modules/configurationModule/detail/automation/assays/services/configuration-ontology-for-automatic-assay/configuration-ontology-for-automatic-assay.dto'
import { store } from '@/store/store'

export const columnsDefAutomationAssaysGrid =
    (): ColDef[] => [
        { type: AgGridColumnType.CUSTOM_CHECKBOX },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.sections.sampleType'),
            field: 'sampleType.description',
            minWidth: 250,
            suppressSizeToFit: true,
            filter: true,
            sortable: true
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.grid.topographicCode'),
            field: 'topographicCode.description',
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true,
            filter: true,
            sortable: true
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.sections.procedures'),
            field: 'procedure.description',
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true,
            filter: true,
            sortable: true
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.sections.mostLikelyDiagnoses'),
            field: 'mostLikelyMorphologicCode.description',
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true,
            filter: true,
            sortable: true
        }
    ]

export interface ConfigurationAutomationAssaysGridState extends CrudModelPaginatorLaboratory<ConfigurationOntologyForAutomaticAssayResponse> {
    service: typeof configurationOntologyForAutomaticAssayService
    laboratoryId: number
}
export const initialConfigurationAutomationAssaysGridState =
    (): ConfigurationAutomationAssaysGridState => ({
        ...initialCrudModelBaseState(),
        gridUiComponent: 'uicomponent.configuration.local.automation.assays',
        columnsDef: columnsDefAutomationAssaysGrid(),
        datasource: new PaginatorLaboratoryDatasource(configurationOntologyForAutomaticAssayService, store.getters.labId),
        service: configurationOntologyForAutomaticAssayService,
        laboratoryId: store.getters.labId
    })
